import { ImageProps as NextImageProps } from 'next/image';

const ENVIROMENT = process.env.NODE_ENV;

interface ImageProps extends NextImageProps {
    forceSrc?: boolean;
}

const Image = (props: ImageProps) => {
    const { src, fill, forceSrc, ...rest } = props;
    const baseUrl = ENVIROMENT === 'development' ? '' : '/festival-2024';
    const imagePath = baseUrl + src;

    // eslint-disable-next-line @next/next/no-img-element, jsx-a11y/alt-text
    return <img src={forceSrc ? String(src) : imagePath} {...rest} />;
};

export default Image;
